export default __webpack_public_path__ + "static/media/secure.38153b7b.svg";